import { render, staticRenderFns } from "./EventsFilters.vue?vue&type=template&id=25647e04&scoped=true&"
import script from "./EventsFilters.vue?vue&type=script&lang=js&"
export * from "./EventsFilters.vue?vue&type=script&lang=js&"
import style0 from "./EventsFilters.vue?vue&type=style&index=0&id=25647e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25647e04",
  null
  
)

export default component.exports